import { getElementContainerFlexes } from './NodeElementUtils';

export const getFlexesForAppend = (
  containerNode,
  { parentElement, percentX, percentY }
) => {
  const flexesMutable = getFlexesMutable(parentElement);
  const flexTarget = getIsHorizontalNode(containerNode) ? percentY : percentX;
  const flexToSubdivide = flexesMutable.pop();
  const flexPrimary = flexToSubdivide * flexTarget;
  flexesMutable.push(flexPrimary);
  const flexSecondary =
    1 - flexesMutable.reduce((acc, curr) => acc + Number(curr), 0);
  flexesMutable.push(flexSecondary);
  return flexesMutable;
};

export const getFlexesForInsert = (
  containerNode,
  { parentElement, percentX, percentY },
  idx
) => {
  const flexesMutable = getFlexesMutable(parentElement);
  const flexTarget = getIsHorizontalNode(containerNode) ? percentY : percentX;
  const flexToSubdivide = flexesMutable[idx];
  const flexPrimary = flexToSubdivide * flexTarget;
  flexesMutable.splice(idx, 1, flexPrimary);
  const flexSecondary =
    1 - flexesMutable.reduce((acc, curr) => acc + Number(curr), 0);
  flexesMutable.splice(idx + 1, 0, flexSecondary);
  return flexesMutable;
};

export const getFlexesForMerge = (parentElement, idx) => {
  const flexesMutable = getFlexesMutable(parentElement);
  const flexAdditive = flexesMutable.splice(idx, 1)[0];
  const isTail = idx === flexesMutable.length;
  flexesMutable[isTail ? idx - 1 : idx] += flexAdditive;
  return flexesMutable;
};

export const getFlexesMutable = (parentElement) => {
  const currentFlexes = getElementContainerFlexes(parentElement);
  const flexesMutable = [...currentFlexes.map((flex) => Number(flex))];
  return flexesMutable;
};

export const getFlexPrimary = (node, relativeInputPosition) => {
  return getIsHorizontalNode(node)
    ? relativeInputPosition.percentY
    : relativeInputPosition.percentX;
};

export const getIsAppendNode = (node, hash, type) => {
  const parentContainer = getParentContainerNode(node, hash);
  return parentContainer.type === type;
};

export const getIsHorizontalNode = (node) => node.type === 'horizontal';
export const getIsVerticalNode = (node) => node.type === 'vertical';
export const getIsElementNode = (node) => node.type === 'element';

export const getIsNestingContainerNode = (adjacentElementNode, hash) => {
  const { nodeIds } = adjacentElementNode;
  const id = nodeIds[0];
  const node = hash[id];
  return nodeIds.length === 1 && getIsNestedContainer(node);
};

export const getIsNestedContainer = (node) =>
  getIsHorizontalNode(node) || getIsVerticalNode(node);

export const getIsRootNode = (node) => {
  return node.meta.parentId === null;
};

export const getSoleAdjacentElementNode = (nodes, id) => {
  if (nodes.length !== 3) {
    throw new Error(
      'Nodes count must be exactly 3 (element | splitter | element)'
    );
  }
  return nodes.find((node) => node.id !== id && getIsElementNode(node));
};

export const getParentContainerNode = (node, nodeHash) => {
  const parentElement = getParentElementNode(node, nodeHash);
  const parentContainerId = parentElement.meta.parentId;
  const parentContainer = nodeHash[parentContainerId];
  return parentContainer;
};

export const getParentElementNode = (node, nodeHash) => {
  const parentElementId = node.meta.parentId;
  const parentElement = nodeHash[parentElementId];
  return parentElement;
};

export const collectNodes = (array, result) => {
  array.forEach((el) => {
    if (el.nodes) {
      collectNodes(el.nodes, result);
    }
    result.push(el);
  });
  return result;
};
